import './TodayAffirmation.scss'

import { useEffect, useState } from 'react'
import parse from 'html-react-parser'

import { getDailyAffirmation } from '../../common/api/Practices'
import Loading from '../../../templates/Loading'

import vectorLeft from '../../../assets/images/vectorLeft.svg'
import vectorRight from '../../../assets/images/vectorRight.svg'

export default function TodayAffirmation({ cache }) {
  const [todayAffirmation, setTodayAffirmation] = useState()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    ;(async function getDailyAffirmationAsync() {
      // Check cache first
      let affirmation = ''

      try {
        affirmation = await cache.tryGetAsyncResult(
          'dailyAffirmation',
          getDailyAffirmation,
          this
        )

        // Replace slashes. Don't add line breaks because it looks weird on mobile
        // for the daily affirmation to wrap early
        if (affirmation?.length) affirmation = affirmation.replaceAll('/', '')
      } catch (e) {
        console.error(e)
      }

      setTodayAffirmation(affirmation)
      setIsLoading(false)
    })()
  }, [cache])

  return (
    <Loading isLoaded={isLoading || !todayAffirmation} hasContainer={false}>
      <div className='daily-affirmation position-relative mt-5'>
        <img
          src={vectorLeft}
          alt='left side vector'
          className='left-side-vector position-absolute d-md-none'
          loading='lazy'
        />
        <span className='daily-affirmation-text p-4 overflow-hidden d-flex align-items-center justify-content-center'>
          &ldquo;{todayAffirmation && parse(todayAffirmation)}&rdquo;
        </span>
        <img
          src={vectorRight}
          alt='right side vector'
          className='right-side-vector position-absolute d-md-none'
          loading='lazy'
        />
      </div>
    </Loading>
  )
}
